import { ComponentWrapper, MediaContextProvider } from "./..";
import MobileFooter from "./mobileFooter";
import PcFooter from "./pcFooter";
import "./style/index.css";
import cx from 'classnames';
import React from 'react';
var NavigationFooter = function NavigationFooter(props) {
  var innerClassName = props.innerClassName,
    className = props.className,
    style = props.style,
    innerStyle = props.innerStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, 'dr-footer'),
    style: style
  }, /*#__PURE__*/React.createElement(MediaContextProvider, null, /*#__PURE__*/React.createElement(ComponentWrapper, null, /*#__PURE__*/React.createElement(PcFooter, {
    innerClassName: innerClassName,
    innerStyle: innerStyle
  })), /*#__PURE__*/React.createElement(ComponentWrapper, {
    mode: "notPC"
  }, /*#__PURE__*/React.createElement(MobileFooter, null))));
};
export default NavigationFooter;